let lastScrollTop = 0,
	$body = $('body');

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.team();
		Vegas.fixedScrollTo($(window));
		Vegas.headerScroll($(window));
	},

	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.headerScroll($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		$('.vg-nav').vegasMenu();

		//
		$('[data-toggle=tooltip]').tooltip();
	},

	popup: function () {
		$('[data-modal]').click(function () {
			let returnModal = $(this).data('close') || false;
			ModalVegas.init($(this));

			if (!returnModal) return false;
		});
	},

	carousel: function () {
		OwlVegas.init('owl-carousel');
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	team: function () {
		$('.getMember').click(function () {
			let $self = $(this),
				member = $self.data('member'),
				img = $self.attr('href'),
				$member = $('.vg-team__member');

			$('.vg-team__members').find('a').removeClass('active');
			$self.addClass('active');

			$('.vg-team__image').find('.image-area img').attr('src', img);
			$member.hide();
			$('[data-member="' + member + '"]').show();

			return false;
		});
	},

	headerScroll: function($self) {
		let $sticky = $('.vg-hdr-fixed'),
			scroll = $self.scrollTop(),
			scroll_hide = 65;

		if (scroll > 130) {
			$body.addClass('vg-hdr--is-scroll');

			if (scroll > lastScrollTop) {
				$sticky.css('top', -scroll_hide);
				$body.removeClass('vg-hdr--is-fixed');
			} else {
				$sticky.css('top', 0);
				$body.addClass('vg-hdr--is-fixed');
			}

			lastScrollTop = scroll;

		} else {
			$sticky.css('top', -scroll_hide);
			$body.removeClass('vg-hdr--is-scroll vg-hdr--is-fixed');
		}
	},
};
